import { lazy, useEffect, useState } from "react"
import Spinner from "../../components/Spinner"
import jwtDecode from "jwt-decode"

const Dashboard = lazy(() => import("../Dashboard/Dashboard"))
const AdminDashboard = lazy(() => import("../operations/Operations"))
const TutorDashboard = lazy(() =>
  import("../TutorPortal/TutorDashboard/Dashboard")
)
const SeniorTutorDashboard = lazy(() =>
  import("../SeniorTutorPortal/SeniorTutorDashboard/Dashboard")
)
const ParentDashboard = lazy(() =>
  import("../ParentPortal/ParentDashboard/Dashboard")
)

const SchoolDashboard = lazy(() =>
  import("../SchoolPortal/SchoolDashboaard/SchoolDashboard")
)

export default function Root() {
  const [role, setRole] = useState("")

  useEffect(() => {
    setRole(jwtDecode(localStorage.getItem("token")).role)
  }, [])

  if (!role) return <Spinner type="child" />

  if (role === "School Manager") return <SchoolDashboard />
  if (role === "Admin") return <AdminDashboard />
  if (role === "Student") return <Dashboard />
  if (role === "Tutor") return <TutorDashboard />
  if (role === "Senior Tutor") return <SeniorTutorDashboard />
  if (role === "Parent") return <ParentDashboard />
}
